import {useEffect, useMemo, useState} from "react";
import { useDispatch, useSelector } from "react-redux";

import { selectProfile } from "../../../store/profileDetail/selector/selectProfile";

import { Controller, useForm } from "react-hook-form";
import { updateProfile } from "../../../store/profileForm/actions/updateProfile";
import {
  IonButton,
  IonInput,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonList,
  IonRow,
  IonSpinner,
  IonToggle,
} from "@ionic/react";
import InputErrorMessage from "../../../components/InputErrorMessage";
import { appPages } from "../../../utils/appPages";
import { AppPage } from "../../../@types/appPage";
import { selectUpdateStatus } from "../../../store/profileDetail/selector/selectUpdateStatus";
import { AssignFormToProfile } from "./AssignFormToProfile";
import { findFormListByProfile } from "../../../store/profileFormAssigned/actions/findFormListByProfile";

export const ProfileSegmentGeneral: React.FC = () => {
  const [showAssignForm, setShowAssignForm] = useState(false);
  const dispatch = useDispatch();
  const profile = useSelector(selectProfile);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const updateStatus = useSelector(selectUpdateStatus);

  const [appPagesFormData, setAppPagesFormData] = useState<AppPage[]>(
    appPages
      .filter(({ menu }) => menu)
      .map((appPage) => ({
        ...appPage,
        checked: profile.privileges?.includes(appPage.title),
      }))
  );

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: profile.name,
      description: profile.description,
    },
  });

  const handleOnChange = (appPageChecked: AppPage) => {
    setAppPagesFormData(
      appPagesFormData.map((appPageItem) => ({
        ...appPageItem,
        checked:
          appPageChecked.title === appPageItem.title
            ? !appPageChecked.checked
            : appPageItem.checked,
      }))
    );
    setButtonDisabled(false);
  };

  const onSubmit = async (data: object) => {
    const privileges: string[] = appPagesFormData
      .filter(({ checked }) => checked)
      .map(({ title }) => title);
    dispatch(updateProfile({ ...data, privileges }));
  };

  // Logica de mostrar y ocultar ventana para asignar plantillas al perfil
  const handleShowAssignForm = () => setShowAssignForm(true);
  const handleCloseAssignForm = () => {
    setShowAssignForm(false);
  }

  useEffect(() => {
    dispatch(findFormListByProfile(profile.id));
  },[dispatch]);

  const controllers = useMemo(()=>{
    return [({ field: { onChange, value } }:any) => (
      <IonInput
        onIonChange={(e) => {
          onChange(e.detail.value);
          setButtonDisabled(false);
        }}
        value={value}
        {...register("name", {
          required: "Campo obligatorio.",
        })}
      ></IonInput>
    ),({ field: { onChange, value } }:any) => (
      <IonInput
        onIonChange={(e) => {
          onChange(e.detail.value);
          setButtonDisabled(false);
        }}
        value={value}
        {...register("description", {
          required: "Campo obligatorio.",
        })}
      ></IonInput>
    )]
  },[])

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} style={{ padding: 18 }} noValidate>
        <IonItem lines="inset">
          <IonLabel position="stacked">Nombre</IonLabel>
          <Controller
            control={control}
            name="name"
            render={controllers[0]}
          />
        </IonItem>
        <InputErrorMessage errorMessage={errors.name?.message || ""} paddingLeft={15} />

        <IonItem lines="inset">
          <IonLabel position="stacked">Descripción</IonLabel>
          <Controller
            control={control}
            name="description"
            render={controllers[1]}
          />
        </IonItem>
        <InputErrorMessage errorMessage={errors.description?.message || ""} paddingLeft={15} />

        <IonRow style={{ display: "flex", justifyContent: "end", padding: "10px" }} >
          <IonButton color="primary" onClick={handleShowAssignForm}>Asignar plantillas</IonButton>
        </IonRow>
        <AssignFormToProfile show={showAssignForm} handleClose={handleCloseAssignForm} />

        <IonList>
          <IonItemDivider>Privilegios</IonItemDivider>
          {appPagesFormData.map((appPage, index) => (
            <IonItem key={index}>
              <IonLabel>{appPage.title}</IonLabel>
              <IonToggle checked={appPage.checked} onIonChange={() => handleOnChange(appPage)} />
            </IonItem>
          ))}
        </IonList>

        <IonButton
          disabled={buttonDisabled || updateStatus === "pending"}
          type="submit"
          expand="block"
          style={{ marginTop: 40 }}
        >
          {updateStatus === "pending" ? <IonSpinner /> : "Editar"}
        </IonButton>
      </form>
    </>
  );
};
